import React, { useState } from "react";

// Shows a generated password exactly once. It cannot be looked up again, only reset.
export default function SecretBox({ title, login, password, onDone }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`Login: ${login}\nTemporary password: ${password}`);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  return (
    <div className="secret-box" role="alert">
      <b>{title}</b>
      <p>This temporary password is shown only once. Share it securely; the person must change it at first login.</p>
      <div>
        <span>Login</span>
        <code>{login}</code>
      </div>
      <div>
        <span>Temporary password</span>
        <code>{password}</code>
      </div>
      <div className="secret-actions">
        <button className="outline-btn" onClick={copy}>
          {copied ? "Copied ✓" : "Copy details"}
        </button>
        <button className="primary-btn" onClick={onDone}>
          I have saved it
        </button>
      </div>
    </div>
  );
}
